/**
 * Wrapping class for the result of a try/catch statement that, by design, contains {@link unknown} type.
 */
export class WrappedError extends Error {
    constructor(cause) {
        super('wrapped cause', { cause });
    }
    static ifNotAlreadyError(cause) {
        return cause instanceof Error ? cause : new WrappedError(cause);
    }
}
/**
 * Wraps a {@link throwable} function execution to handle and return a fallback value if an error arises instead
 * of throwing.
 *
 * @param throwable Function that can potentially throw an error.
 * @param handler Callback handler that returns a fallback value if the {@link throwable} threw.
 * @returns Either the result of the throwable execution if it succeeded, or the handler fallback value otherwise.
 */
export const tryOrHandle = (throwable, handler) => {
    try {
        return throwable();
    }
    catch (error) {
        return handler(WrappedError.ifNotAlreadyError(error));
    }
};
//# sourceMappingURL=throwable.js.map